import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <rect width={64} height={64} fill="#FF8A00" rx={32} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M30.42 36.8a1 1 0 0 1-.982-.811l-3.615-18.8A1 1 0 0 1 26.805 16h10.379a1 1 0 0 1 .982
      1.189l-3.616 18.8a1 1 0 0 1-.982.811H30.42ZM31.994 48a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
